import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';

import { useAuth } from '../../context/AuthContext';

type Props = {
  onSuccess?: () => void;
  onError?: (error: string) => void;
};

const GoogleLoginButton = ({ onSuccess, onError }: Props) => {
  const { loginWithGoogle } = useAuth();

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        await loginWithGoogle(tokenResponse.access_token);
        onSuccess && onSuccess();
      } catch (error: any) {
        console.error('Google login failed', error);
        toast.error(error.message || 'Logowanie przez Google nie powiodło się');
        onError && onError(error.message);
      }
    },
    onError: (errorResponse) => {
      console.error('Google login error', errorResponse);
      toast.error('Nie udało się zalogować przez Google');
      onError && onError('Logowanie przez Google nie powiodło się');
    },
  });

  return (
    <motion.button
      type="button"
      onClick={() => googleLogin()}
      className="flex items-center justify-center gap-2 w-full bg-white py-2.5 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
      whileHover={{ scale: 1.02, backgroundColor: '#f9fafb' }}
      whileTap={{ scale: 0.98 }}
    >
      <svg className="h-5 w-5" fill="#4285F4" viewBox="0 0 24 24">
        <path d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z" />
      </svg>
      <span>Logowanie przez Google</span>
    </motion.button>
  );
};

export default GoogleLoginButton;
